export function useNextRoute(to) {
  const next = /[a-z]/i.test(to.path) ? to.path : null;
  return { next };
}
